"use client"

// src/icon.tsx
import { FontAwesomeIcon as OriginalFontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forwardRef } from "@yamada-ui/core";
import { Icon as UIIcon } from "@yamada-ui/icon";
import { cx } from "@yamada-ui/utils";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var FontAwesomeIcon = forwardRef(
  ({ className, fontSize, icon, __css, ...rest }, ref) => {
    const css = useMemo(
      () => ({
        color: "currentcolor",
        display: "inline-block",
        flexShrink: 0,
        fontSize,
        ...__css
      }),
      [__css, fontSize]
    );
    return /* @__PURE__ */ jsx(
      UIIcon,
      {
        ref,
        as: OriginalFontAwesomeIcon,
        className: cx("ui-fontawesome-icon", className),
        icon,
        __css: css,
        ...rest
      }
    );
  }
);
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.__ui__ = "FontAwesomeIcon";
var Icon = FontAwesomeIcon;

export {
  FontAwesomeIcon,
  Icon
};
//# sourceMappingURL=chunk-6GZBO2NE.mjs.map